// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentDetails_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, defaultDocument?: { __typename?: 'Document', id: string } | null };

export type DocumentDetails_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export type DocumentDetails_DocumentSummaryFragment = { __typename?: 'DocumentSummary', id: string, summary: string, displayName: string, aiSummaryRating?: Types.DocumentSummaryAiSummaryRating | null, aiSummaryFeedback?: string | null, entryMode?: Types.DocumentSummaryEntryMode | null, summaryFormat?: Types.DocumentSummarySummaryFormat | null, createdBy: string, createdAt: Time, updatedAt: Time, sourceDocuments: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null }, generatedFromPrompt?: { __typename?: 'DocumentSummaryPrompt', id: string, isDefaultForDocType: boolean } | null, updateUser: { __typename?: 'User', id: string, displayName: string } };

export type DocumentDetails_DocumentFragment = { __typename?: 'Document', id: string, displayType: string, name: string, type: Types.DocumentType, updatedAt: Time, createdAt: Time, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: (
          { __typename?: 'Entity' }
          & DocumentDetails_EntityFragment
        ) | null, testamentaryEntity?: (
          { __typename?: 'TestamentaryEntity' }
          & DocumentDetails_TestamentaryEntityFragment
        ) | null } | null } | null> | null }, summaries?: Array<(
    { __typename?: 'DocumentSummary' }
    & DocumentDetails_DocumentSummaryFragment
  )> | null, defaultDocumentOfEntity?: { __typename?: 'Entity', id: string } | null, household: { __typename?: 'Household', id: string, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
          { __typename?: 'Entity' }
          & DocumentDetails_EntityFragment
        ) | null } | null> | null }, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
          { __typename?: 'TestamentaryEntity' }
          & DocumentDetails_TestamentaryEntityFragment
        ) | null } | null> | null } }, user: { __typename?: 'User', id: string, displayName: string }, clientProfile?: { __typename?: 'ClientProfile', id: string } | null, file: { __typename?: 'File', id: string, pages?: Array<{ __typename?: 'FilePage', id: string, pageNumber: number, width?: number | null, height?: number | null, unit?: string | null }> | null }, pdfFile?: { __typename?: 'File', id: string, pages?: Array<{ __typename?: 'FilePage', id: string, pageNumber: number, width?: number | null, height?: number | null, unit?: string | null }> | null } | null };

export type DocumentDetailsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DocumentWhereInput>;
}>;


export type DocumentDetailsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & DocumentDetails_DocumentFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DocumentDetails: 'DocumentDetails' as const
  },
  Fragment: {
    DocumentDetails_Entity: 'DocumentDetails_Entity' as const,
    DocumentDetails_TestamentaryEntity: 'DocumentDetails_TestamentaryEntity' as const,
    DocumentDetails_DocumentSummary: 'DocumentDetails_DocumentSummary' as const,
    DocumentDetails_Document: 'DocumentDetails_Document' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DocumentDetails_EntityFragmentDoc = gql`
    fragment DocumentDetails_Entity on Entity {
  id
  kind
  stage
  subtype {
    id
    displayName
  }
  defaultDocument {
    id
  }
}
    `;
export const DocumentDetails_TestamentaryEntityFragmentDoc = gql`
    fragment DocumentDetails_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
  createdFromEntities {
    edges {
      node {
        id
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;
export const DocumentDetails_DocumentSummaryFragmentDoc = gql`
    fragment DocumentDetails_DocumentSummary on DocumentSummary {
  id
  summary
  displayName
  sourceDocuments(first: 100) {
    edges {
      node {
        id
        name
      }
    }
  }
  generatedFromPrompt {
    id
    isDefaultForDocType
  }
  aiSummaryRating
  aiSummaryFeedback
  entryMode
  summaryFormat
  createdBy
  createdAt
  updateUser {
    id
    displayName
  }
  updatedAt
}
    `;
export const DocumentDetails_DocumentFragmentDoc = gql`
    fragment DocumentDetails_Document on Document {
  id
  entityDocumentRelationships {
    edges {
      node {
        id
        relationshipType
        entity {
          ...DocumentDetails_Entity
        }
        testamentaryEntity {
          ...DocumentDetails_TestamentaryEntity
        }
      }
    }
  }
  displayType
  summaries {
    ...DocumentDetails_DocumentSummary
  }
  defaultDocumentOfEntity {
    id
  }
  name
  type
  updatedAt
  createdAt
  household {
    id
    entities {
      edges {
        node {
          ...DocumentDetails_Entity
        }
      }
    }
    testamentaryEntities {
      edges {
        node {
          ...DocumentDetails_TestamentaryEntity
        }
      }
    }
  }
  user {
    id
    displayName
  }
  clientProfile {
    id
  }
  file {
    id
    pages {
      id
      pageNumber
      width
      height
      unit
    }
  }
  pdfFile {
    id
    pages {
      id
      pageNumber
      width
      height
      unit
    }
  }
}
    ${DocumentDetails_EntityFragmentDoc}
${DocumentDetails_TestamentaryEntityFragmentDoc}
${DocumentDetails_DocumentSummaryFragmentDoc}`;
export const DocumentDetailsDocument = gql`
    query DocumentDetails($where: DocumentWhereInput) {
  documents(where: $where) {
    edges {
      node {
        ...DocumentDetails_Document
      }
    }
  }
}
    ${DocumentDetails_DocumentFragmentDoc}`;

/**
 * __useDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext(options));
      }
export function useDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentDetailsQuery, DocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentDetailsQuery, DocumentDetailsQueryVariables>(DocumentDetailsDocument, withFetchPolicyContext(options));
        }
export type DocumentDetailsQueryHookResult = ReturnType<typeof useDocumentDetailsQuery>;
export type DocumentDetailsLazyQueryHookResult = ReturnType<typeof useDocumentDetailsLazyQuery>;
export type DocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useDocumentDetailsSuspenseQuery>;
export type DocumentDetailsQueryResult = Apollo.QueryResult<DocumentDetailsQuery, DocumentDetailsQueryVariables>;